import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=68d966c6&scoped=true&"
import script from "./PageWrapper.vue?vue&type=script&lang=ts&"
export * from "./PageWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d966c6",
  null
  
)

export default component.exports